export default __webpack_public_path__ + "static/media/si.3aa260cd.svg";